import React, { useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/diagram-logo.svg';
import Navigation from './Navigation';

const AuthenticatedHeader = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const navigate = useNavigate();
  
  const goToHomePage = () => {
    navigate('/');
  };

  const displayName = user?.username || 'User';

  const handleSignOut = async () => {
    try {
      await signOut({ global: true });
      navigate('/');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-left" onClick={goToHomePage} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="DiagramLoom Logo" className="logo" />
          <div className="company-info">
            <h1 className="company-name">DiagramLoom</h1>
            <p className="slogan">Generative Design Assistant</p>
          </div>
        </div>
        <div className="header-right">
          <p className="contact-info">Transform Ideas into Working Products</p>
          {user && (
            <div className="account-menu-container">
              <button 
                onClick={() => setShowAccountMenu(!showAccountMenu)}
                className="account-button"
              >
                {displayName} ▼
              </button>
              {showAccountMenu && (
                <div className="account-dropdown">
                  <button 
                    onClick={() => {
                      setShowAccountMenu(false);
                      handleSignOut();
                    }}
                    className="dropdown-item"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Navigation />
    </header>
  );
};

const PublicHeader = () => {
  const navigate = useNavigate();
  
  const goToHomePage = () => {
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-left" onClick={goToHomePage} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="DiagramLoom Logo" className="logo" />
          <div className="company-info">
            <h1 className="company-name">DiagramLoom</h1>
            <p className="slogan">Generative Design Assistant</p>
          </div>
        </div>
        <div className="header-right">
          <p className="contact-info">Transform Ideas into Working Products</p>
        </div>
      </div>
    </header>
  );
};

const Header = ({ isPublic = false }) => {
  return isPublic ? <PublicHeader /> : <AuthenticatedHeader />;
};

export default Header;